import _asyncToGenerator from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/app/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";

function _init(Swiper, VisSenseFactory) {
  var containers = document.querySelectorAll('.js-swiper-container');
  [].forEach.call(containers, function (container) {
    var pagination = container.querySelector('.js-swiper-pagination');
    var itemsCount = +container.dataset.itemsCount;
    var slidesCount = container.querySelectorAll('.com-sec-slider-3__slide').length;
    var sliderSwiper = new Swiper(container, {
      slidesPerView: 3,
      slidesPerGroup: 3,
      pagination: {
        el: pagination,
        clickable: true,
        renderBullet: function renderBullet(index, className) {
          return slidesCount > 3 ? '<span class="com-sec-slider-3__pagination-item ' + className + '">' + '<span class="com-sec-slider-3__pagination-element"></span>' + '</span>' : '';
        }
      },
      loop: false,
      centerInsufficientSlides: true,
      speed: 700,
      breakpoints: {
        479: {
          slidesPerView: itemsCount ? itemsCount : 5,
          slidesPerGroup: itemsCount ? itemsCount : 5,
          pagination: {
            el: pagination,
            clickable: true,
            renderBullet: function renderBullet(index, className) {
              return slidesCount > 5 ? '<span class="com-sec-slider-3__pagination-item ' + className + '">' + '<span class="com-sec-slider-3__pagination-element"></span>' + '</span>' : '';
            }
          }
        }
      }
    });
    var section = document.querySelector('.com-sec-slider-3');
    var VisSense = VisSenseFactory(window);
    var visibility = VisSense(section, {
      fullyvisible: 0.6
    });
    visibility.monitor({
      fullyvisible: function fullyvisible() {
        if (scroll) {
          sliderSwiper.autoplay.start();
          scroll = false;
        }
      }
    }).start();
  });
}

export default {
  init: function () {
    var _init2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var isBrowser, _yield$import, Swiper, Navigation, Pagination, Autoplay, _yield$import2, VisSenseFactory;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              isBrowser = true;

              if (!isBrowser) {
                _context.next = 15;
                break;
              }

              _context.next = 4;
              return import('swiper');

            case 4:
              _yield$import = _context.sent;
              Swiper = _yield$import["default"];
              Navigation = _yield$import.Navigation;
              Pagination = _yield$import.Pagination;
              Autoplay = _yield$import.Autoplay;
              Swiper.use([Navigation, Pagination, Autoplay]);
              _context.next = 12;
              return import('vissense');

            case 12:
              _yield$import2 = _context.sent;
              VisSenseFactory = _yield$import2["default"];

              _init(Swiper, VisSenseFactory);

            case 15:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    function init() {
      return _init2.apply(this, arguments);
    }

    return init;
  }()
};